<template>
  <div>
    <div class="wpc-form-row" style="margin-bottom:0;">
      <!-- <label>Location</label> -->
      <div
        class="mbox cal-accs"
        style="margin-bottom:0;"
        v-drag-and-drop:options="
          selected_locations.length > 1
            ? selected_locations_drag_drop_options
            : {}
        "
        :key="selected_locations.length > 1 ? 100 : 0"
      >
        <!-- :key helps in re-render drag and drop -->
        <div class="set-locations-cont" @reordered="reorder_selected_locations">
          <div
            class="set-locations-single"
            :class="{
              ['location_' + selected_location.type]: true,
              'del-alert': show_delete_alert(index)
            }"
            v-for="(selected_location, index) in selected_locations"
            :key="index"
            :data-id="index"
          >
            <div
              :class="{ 'reorder-handle': selected_locations.length > 1 }"
            ></div>
            <div class="txt-h5">
              {{ selected_location.type | location_name_by_type }}
              <a
                style="margin-right: 30px; margin-left:auto;"
                v-if="is_having_edit_options(selected_location)"
                @click="may_show_popup_form(selected_location, 'edit', index)"
                >{{ T__("EDIT") }}</a
              >
            </div>
            <div
              class="icon-delete"
              @click="
                remove_from_selected_locations(index);
                set_mouseover(index, false);
              "
              @mouseover="set_mouseover(index, true)"
              @mouseleave="set_mouseover(index, false)"
            ></div>
            <div
              class="txt-help"
              v-if="
                is_tp_service_account_connected(selected_location.type) !==
                  false
              "
            >
              {{ get_meta_data_for_location(selected_location) }}
            </div>
            <div
              class="txt-help"
              style="margin-top:5px; color:#ea1919;"
              v-if="
                is_tp_service_account_connected(selected_location.type) ===
                  false
              "
            >
              {{ tp_service_not_connected_text(selected_location) }}
              <span
                v-html="
                  tp_service_not_connected_to_do_content(selected_location)
                "
              >
              </span>
            </div>
          </div>
        </div>
        <span
          class="txt-help"
          style="padding-top:0; padding-bottom:5px;"
          v-if="selected_locations.length"
          >{{
            T__(
              "You can give more location options from which your invitees can choose one."
            )
          }}</span
        >
        <button
          class="wpc-btn secondary md full-width"
          @click="show_add_location_list = true"
          v-if="!show_add_location_list"
          :disabled="!enable_add_new_location"
          :title="
            !enable_add_new_location
              ? this.T__('You can add only upto 10 locations.')
              : ''
          "
        >
          {{ T__("+ Add Location") }}
        </button>
        <div v-if="show_add_location_list">
          <div class="txt-h5 caps">{{ T__("Add a Location") }}</div>
          <ul class="selector block compact location">
            <li v-for="(location, index2) in all_locations_final" :key="index2">
              <label
                @click="add_to_selected_locations(location)"
                :class="'location_' + location.type"
                ><div class="txt-h5">
                  {{ location.type | location_name_by_type }}
                </div>
                <div class="txt-help">
                  {{ location.type | location_short_descr_by_type }}
                </div></label
              >
              <!-- <label
                v-if="location.type == 'zoom_meeting'"
                :class="'location_' + location.type"
                ><div class="txt-h5">
                  Zoom <span class="tag">Coming soon</span
                  ><span
                    style="float: right; font-size: 11px; margin-right: 10px;"
                    ><a
                      href="https://help.wpcal.io/article/how-to-use-zoom-or-any-other-app-that-uses-an-invitation-link-with-wpcal"
                      target="_blank"
                      >See a workaround
                      <span
                        style="font-size: 11px; font-weight: 600; position: absolute; margin: 2px;"
                        >↗</span
                      ></a
                    ></span
                  >
                </div>
                <div class="txt-help">
                  {{ location.type | location_short_descr_by_type }}
                </div>
              </label> -->
            </li>
          </ul>
        </div>
      </div>
    </div>

    <modal
      name="location_advance_modal"
      :adaptive="true"
      height="auto"
      width="360px"
      style="z-index:9999;"
      @before-close="location_advance_modal_on_before_close"
    >
      <div class="modal_close_cont">
        <button @click="$modal.hide('location_advance_modal')"></button>
      </div>
      <div class="mbox bg-light shadow mb0">
        <div
          style="font-size:16px; text-align:center; margin-bottom:10px;padding: 5px 0;"
        >
          {{ current_popup_location.type | location_name_by_type }}
        </div>
        <div v-if="current_popup_location.form">
          <form-row
            :validator="$v.current_popup_location.form.who_calls"
            v-if="current_popup_location.form.hasOwnProperty('who_calls')"
          >
            <ul class="selector block mt10 ">
              <li>
                <input
                  type="radio"
                  id="who_calls_admin"
                  name="who_calls"
                  v-model="current_popup_location.form.who_calls"
                  value="admin"
                />
                <label for="who_calls_admin">
                  <div class="txt-h5">{{ T__("I will call my invitee") }}</div>
                  <div class="txt-help" style="padding-top:0;">
                    {{
                      T__(
                        "We'll ask your invitee’s phone number before scheduling."
                      )
                    }}
                  </div></label
                >
              </li>
              <li>
                <input
                  type="radio"
                  id="who_calls_invitee"
                  name="who_calls"
                  v-model="current_popup_location.form.who_calls"
                  value="invitee"
                  @focus="ref_focus('location_txt')"
                  @click="ref_focus('location_txt')"
                />
                <label for="who_calls_invitee">
                  <div class="txt-h5">
                    {{ T__("My invitee should call me") }}
                  </div>
                  <div class="txt-help" style="padding-top:0;">
                    {{
                      T__(
                        "We'll provide your number after the call has been scheduled."
                      )
                    }}
                  </div></label
                >
              </li>
            </ul>
          </form-row>
          <form-row
            :validator="$v.current_popup_location.form.location"
            v-if="popup_show_location_field"
          >
            <label for="location_txt" style="font-size:14px;">{{
              location_feild_label
            }}</label>
            <input
              type="text"
              id="location_txt"
              ref="location_txt"
              v-model="current_popup_location.form.location"
              @change="$v.current_popup_location.form.location.$touch()"
              :maxlength="
                get_maxlength_from_validation(
                  $v.current_popup_location.form.location
                )
              "
            />
            <CharLeft
              v-if="current_popup_location.type != 'phone'"
              :maxlength="
                get_maxlength_from_validation(
                  $v.current_popup_location.form.location
                )
              "
              :input_text="current_popup_location.form.location"
            />
            <template v-slot:after>
              <span class="txt-help">
                {{ location_help_txt }}
              </span>
            </template>
          </form-row>
          <span
            v-if="current_popup_location.form.hasOwnProperty('location_extra')"
          >
            <div class="wpc-form-row">
              <a
                class=""
                v-if="!show_location_extra_field"
                @click="
                  show_location_extra_field = true;
                  ref_focus('location_extra');
                "
              >
                {{ T__("+ Add additional info") }}
              </a>
            </div>
            <form-row
              :validator="$v.current_popup_location.form.location_extra"
              v-if="show_location_extra_field"
            >
              <label for="location_extra" style="font-size:14px;">{{
                T__("Location additional info")
              }}</label>
              <span class="txt-help" style="padding-top:0; padding-bottom:5px;">
                {{ location_extra_help_txt }}
              </span>
              <textarea
                type="text"
                id="location_extra"
                ref="location_extra"
                v-model="current_popup_location.form.location_extra"
                @change="$v.current_popup_location.form.location_extra.$touch()"
                :maxlength="
                  get_maxlength_from_validation(
                    $v.current_popup_location.form.location_extra
                  )
                "
              />
              <CharLeft
                :maxlength="
                  get_maxlength_from_validation(
                    $v.current_popup_location.form.location_extra
                  )
                "
                :input_text="current_popup_location.form.location_extra"
              />
            </form-row>
          </span>
          <button
            type="button"
            class="wpc-btn primary md mt20"
            @click="save_current_popup_location"
          >
            {{
              current_popup_location_action == "add" ? "Add Location" : "Update"
            }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { VueDraggableDirective } from "vue-draggable";

import { required, requiredIf, maxLength } from "vuelidate/lib/validators";

import { in_array } from "@/utils/common_func.js";
import { admin_tp_locations_state_mixin } from "@/utils/admin_tp_locations_state_mixin.js";

import axios from "axios";

import CharLeft from "@/components/form_elements/CharLeft.vue";

export default {
  mixins: [admin_tp_locations_state_mixin(false)],
  components: {
    CharLeft
  },
  directives: {
    dragAndDrop: VueDraggableDirective
  },
  model: {
    prop: "locations",
    event: "locations-value-changed"
  },
  props: {
    locations: {
      type: Array
    },
    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      all_locations: [
        {
          type: "physical",
          limit: -1,
          count: 0,
          show: true,
          form: { location: "", location_extra: "" }
        },
        {
          type: "phone",
          limit: 1,
          count: 0,
          show: true,
          form: {
            who_calls: "admin", //admin - outbound, invitee - inbound so admin should provide number
            location: ""
          }
        },
        {
          type: "googlemeet_meeting",
          limit: 1,
          count: 0,
          show: true
        },
        {
          type: "zoom_meeting",
          limit: 1,
          count: 0,
          show: true
        },
        {
          type: "gotomeeting_meeting",
          limit: 1,
          count: 0,
          show: true
        },
        {
          type: "custom",
          limit: -1,
          count: 0,
          show: true,
          form: { location: "", location_extra: "" }
        },
        {
          type: "ask_invitee",
          limit: 1,
          count: 0,
          show: true,
          form: { location: "", location_extra: "" }
        }
      ],
      show_add_location_list: false,
      current_popup_location: {},
      current_popup_location_action: "",
      current_popup_location_index: null,
      show_location_extra_field: false,
      selected_locations_drag_drop_options: {
        dropzoneSelector: ".set-locations-cont",
        draggableSelector: ".set-locations-single",
        handlerSelector: ".reorder-handle",
        reactivityEnabled: true,
        multipleDropzonesItemsDraggingEnabled: false,
        showDropzoneAreas: true
      },
      delete_alert_index: null
    };
  },
  validations: {
    current_popup_location: {
      type: { required },
      form: {
        required: requiredIf(function() {
          let types_required_form = [
            "physical",
            "phone",
            "custom",
            "ask_invitee"
          ];
          return (
            types_required_form.indexOf(this.current_popup_location.type) !== -1
          );
        }),
        who_calls: {
          required: requiredIf(function() {
            if (this.current_popup_location.type === "phone") {
              return true;
            }
            return false;
          }),
          who_calls_in_array: in_array(["admin", "invitee"])
        },
        location: {
          required: requiredIf(function() {
            let types_required_location = ["physical", "custom"];
            if (
              types_required_location.indexOf(
                this.current_popup_location.type
              ) !== -1
            ) {
              return true;
            } else if (
              this.current_popup_location.type === "phone" &&
              this.current_popup_location.form.who_calls === "invitee"
            ) {
              return true;
            }
            return false;
          }),
          max_char_length_500: maxLength(500)
        },
        location_extra: {
          max_char_length_500: maxLength(500)
        }
      }
    }
  },
  computed: {
    selected_locations: {
      get: function() {
        return this.locations;
      },
      set: function(new_value) {
        this.$emit("locations-value-changed", new_value);
      }
    },
    all_locations_with_stats() {
      let list = this.clone_deep(this.all_locations);
      for (let selected_location of this.selected_locations) {
        let list_index = list.findIndex(list_item => {
          return list_item.type === selected_location.type;
        });
        if (list_index != -1) {
          list[list_index].count++;
          if (
            list[list_index].limit > -1 &&
            list[list_index].limit <= list[list_index].count
          ) {
            list[list_index].show = false;
          } else {
            list[list_index].show = true;
          }
        }
      }
      return list;
    },
    all_locations_final() {
      let list = [];
      for (let index in this.all_locations_with_stats) {
        if (this.all_locations_with_stats[index].show)
          list.push(this.all_locations_with_stats[index]);
      }
      return list;
    },
    enable_add_new_location() {
      return this.selected_locations.length < 10;
    },
    location_feild_label() {
      let label = this.T__("Location");
      if (this.current_popup_location.type == "custom") {
        label = this.T__("Enter a location of your choice");
      } else if (this.current_popup_location.type == "phone") {
        label = this.T__("Enter your phone number");
      }
      return label;
    },
    popup_show_location_field() {
      let show_location = false;
      if (
        this.current_popup_location.type == "physical" ||
        this.current_popup_location.type == "custom"
      ) {
        show_location = true;
      } else if (
        this.current_popup_location.type == "phone" &&
        this.current_popup_location.form &&
        this.current_popup_location.form.who_calls == "invitee"
      ) {
        show_location = true;
      }
      return show_location;
    },
    location_help_txt() {
      if (this.current_popup_location.type == "phone") {
        return (
          this.T__("Please enter phone number with country code. E.g.") +
          " +1 555 555 1234"
        );
      }
      return "";
    },
    location_extra_help_txt() {
      if (
        this.current_popup_location.type == "physical" ||
        this.current_popup_location.type == "custom"
      ) {
        return this.T__(
          "This will be shown to the invitee AFTER the booking is confirmed."
        );
      } else if (this.current_popup_location.type == "ask_invitee") {
        return this.T__(
          "You can use this to guide the invitee. The text you enter here will be displayed below the location text field."
        );
      }
      return "";
    },
    tp_locations_required_admin_user_id() {
      return this.form.service_admin_user_ids[0];
    },
    is_current_admin_is_this_service_host() {
      return (
        this.$store.getters.get_current_admin_details.id ==
        this.form.service_admin_user_ids[0]
      );
    },
    tp_service_not_connected_text() {
      return selected_location => {
        if (this.is_current_admin_is_this_service_host) {
          return this.Tsprintf(
            /* translators: %s: app name */
            this.T__(
              "%s is not connected. Until you do, it will not be displayed to your invitees."
            ),
            this.$options.filters.location_name_by_type(selected_location.type)
          );
        } else {
          return this.Tsprintf(
            /* translators: %s: app name */
            this.T__(
              "%s is not connected. Until the host connects it, it will not be displayed to your invitees."
            ),
            this.$options.filters.location_name_by_type(selected_location.type)
          );
        }
      };
    },
    tp_service_not_connected_to_do_content() {
      return selected_location => {
        if (selected_location.type == "googlemeet_meeting") {
          if (this.is_current_admin_is_this_service_host) {
            return this.Tsprintf(
              /* translators: 1: html-tag-open 2: html-tag-close */
              this.T__(
                "Go to %1$sCalendar settings%2$s connect a calendar account (if not done already), and set &quot;Add Bookings to...&quot; calendar."
              ),
              '<a href="admin.php?page=wpcal_admin#/settings/calendars" target="_blank" style="text-decoration:underline;">',
              "</a>"
            );
          } else {
            return this.Tsprintf(
              this.T__("%1$sLearn more.%2$s"),
              '<a href="https://help.wpcal.io/en/article/how-do-i-connect-my-google-meet-with-wpcalio-hrh77h/?utm_source=wpcal_plugin&utm_medium=contextual" target="_blank">',
              "</a>"
            );
          }
        } else {
          if (this.is_current_admin_is_this_service_host) {
            return this.Tsprintf(
              /* translators: 1: html-tag-open 2: html-tag-close */
              this.T__(
                "Go to the %1$sIntegrations%2$s page to connect it now."
              ),
              '<a href="admin.php?page=wpcal_admin#/settings/integrations" target="_blank" style="text-decoration:underline">',
              "</a>"
            );
          } else {
            let help_link =
              "https://help.wpcal.io/en/article/how-to-connect-use-meeting-apps-bwour0/";
            if (selected_location.type == "zoom_meeting") {
              help_link =
                "https://help.wpcal.io/en/category/integrations-zoom-1dfihfm/";
            }
            return this.Tsprintf(
              this.T__("%1$sLearn more.%2$s"),
              '<a href="' +
                help_link +
                '?utm_source=wpcal_plugin&utm_medium=contextual" target="_blank">',
              "</a>"
            );
          }
        }
      };
    }
  },
  methods: {
    add_to_selected_locations(location) {
      let new_location = {};
      new_location.type = location.type;
      if (location.hasOwnProperty("form") && location.form) {
        new_location.form = this.clone_deep(location.form);
      }

      this.may_show_popup_form(new_location, "add");

      this.show_add_location_list = false;
    },
    remove_from_selected_locations(index) {
      this.show_add_location_list = false;
      this.selected_locations.splice(index, 1);
    },
    may_show_popup_form(location, action, index = null) {
      location = this.clone_deep(location);
      if (action != "add" && action != "edit") {
        return;
      }
      if (action == "edit" && isNaN(index)) {
        return;
      }

      if (!this.is_having_edit_options(location)) {
        if (action == "add") {
          this.selected_locations.push(location);
        } else if (action == "edit") {
          this.selected_locations[index] = location;
        }
        return;
      }

      this.$v["current_popup_location"].$reset();

      this.current_popup_location = location;
      this.current_popup_location_action = action;
      this.current_popup_location_index = index;
      if (
        this.current_popup_location.form &&
        this.current_popup_location.form.hasOwnProperty("location_extra") &&
        this.current_popup_location.form.location_extra
      ) {
        this.show_location_extra_field = true;
      }

      this.$modal.show("location_advance_modal");
      if (
        this.current_popup_location.type == "physical" ||
        this.current_popup_location.type == "custom"
      ) {
        this.ref_focus("location_txt");
      }
    },
    save_current_popup_location() {
      let action = this.current_popup_location_action;
      let index = this.current_popup_location_index;

      this.$v["current_popup_location"].$touch(); //trigger validation
      if (this.$v.current_popup_location.$anyError) {
        return;
      }

      if (action == "add") {
        this.selected_locations.push(this.current_popup_location);
      } else if (action == "edit") {
        this.selected_locations[index] = this.current_popup_location;
      }
      this.$modal.hide("location_advance_modal");
    },
    is_having_edit_options(location) {
      if (location.hasOwnProperty("form") && location.form) {
        return true;
      }
      return false;
    },
    reset_current_popup_location() {
      this.current_popup_location = {};
      this.current_popup_location_action = "";
      this.current_popup_location_index = null;
      this.show_location_extra_field = false;
    },
    location_advance_modal_on_before_close() {
      this.reset_current_popup_location();
    },
    get_meta_data_for_location(location) {
      if (!this.is_having_edit_options(location)) {
        return this.$options.filters.location_short_descr_by_type(
          location.type
        );
      }
      let meta = "";
      if (
        location.type === "phone" &&
        location.form.hasOwnProperty("who_calls") &&
        location.form.who_calls
      ) {
        meta +=
          location.form.who_calls == "admin"
            ? this.T__("I will call my invitee")
            : this.T__("My invitee should call me at ");

        if (
          location.form.who_calls == "invitee" &&
          location.form.hasOwnProperty("location") &&
          location.form.location
        ) {
          meta += location.form.location;
        }
      }
      if (
        location.type !== "phone" &&
        location.form &&
        location.form.hasOwnProperty("location") &&
        location.form.location
      ) {
        meta += location.form.location;
      }
      if (
        location.form &&
        location.form.hasOwnProperty("location_extra") &&
        location.form.location_extra
      ) {
        meta += " " + this.T__("(more info)");
      }
      return meta
        ? meta
        : this.$options.filters.location_short_descr_by_type(location.type);
    },
    reorder_selected_locations(event) {
      let move_item_old_index = event.detail.ids[0];
      let move_item_new_index = event.detail.index;
      let moved_item = this.selected_locations.splice(move_item_old_index, 1);
      let final_item_new_index =
        move_item_old_index < move_item_new_index
          ? move_item_new_index - 1
          : move_item_new_index;
      // console.log(
      //   move_item_old_index,
      //   "to",
      //   move_item_new_index,
      //   "final",
      //   final_item_new_index
      // );
      this.selected_locations.splice(final_item_new_index, 0, moved_item[0]);
    },
    show_delete_alert(index) {
      return this.delete_alert_index === index;
    },
    set_mouseover(index, is_hover) {
      if (is_hover) {
        this.delete_alert_index = index;
      } else {
        this.delete_alert_index = null;
      }
    }
  }
};
</script>
